import LabServiceCollection from "@/collections/LabServiceCollection";
import QualityControlModel from "@/models/lab/QualityControlModel";

export default class QualityControlCollection extends LabServiceCollection {

    model() {
        return QualityControlModel;
    }

}